<template>
  <div class="MinMax">
    
    <div v-for="el in datas" v-bind:key="el.sensor">
        
      <div class="field is-horizontal" >
          
          <div class="columns">
                <div class="column is-one-fifth">
                    <div class="field-label is-small">
                        <label class="label">{{el.sensor+1}}.</label>
                    </div>
                </div>
            
                <div class="column">
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input :id="'sliderMin_'+data.id+'_'+el.sensor" @change="sliderChangeMin"  class="slider has-output is-fullwidth" min="0" max="100" :value="el.valueMin" step="1" type="range">
                                <output :for="'sliderMin_'+data.id+'_'+el.sensor">{{el.valueMin}}</output>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input :id="'sliderMax_'+data.id+'_'+el.sensor" @change="sliderChangeMax" class="slider has-output is-fullwidth" min="0" max="100" :value="el.valueMax" step="1" type="range">
                                <output class="is-light" :for="'sliderMax_'+data.id+'_'+el.sensor">{{el.valueMax}}</output>
                            </div>
                        </div>
                    </div>    
                </div>
                
                
            </div>
            
      </div>
      
    </div>
   <br>
            <button v-if="saving !=  true" class="button is-small" @click="save">Zapisz</button>
            <button v-if="saving ==  true" class="button is-small is-loading ">Zapisz</button>
  </div>
</template>

<script>



export default {
  name: 'MinMax',
  props: {
    data: Object,
    
  },
  data() {
    return {
      datas: [
          {sensor: 0, valueMin: 20, valueMax: 40},
          {sensor: 1, valueMin: 20, valueMax: 45},
          {sensor: 2, valueMin: 40, valueMax: 60},
          {sensor: 3, valueMin: 50, valueMax: 80},
          {sensor: 4, valueMin: 30, valueMax: 50},
      ],
      saving: false
    }
  },
  mounted () {

    var objData = {
      id: this.data.id
    }
    this.$store.dispatch('getLimits', objData)
    .then(response => {
      
      //console.log(response)
      this.buildForm(response[0])
    })
    .catch(error => {
        console.log(error)
        return error
    });
    
    
  },
  methods: {
    buildForm(_data){
      

      for (var i = 0, lei = this.datas.length; i < lei; i++){
        if (i == 0){
          this.datas[i].valueMin = _data.t1_min;
          this.datas[i].valueMax = _data.t1_max;
        }
        if (i == 1){
          this.datas[i].valueMin = _data.t2_min;
          this.datas[i].valueMax = _data.t2_max;
        }
        if (i == 2){
          this.datas[i].valueMin = _data.t3_min;
          this.datas[i].valueMax = _data.t3_max;
        }
        if (i == 3){
          this.datas[i].valueMin = _data.t4_min;
          this.datas[i].valueMax = _data.t4_max;
        }
        if (i == 4){
          this.datas[i].valueMin = _data.t5_min;
          this.datas[i].valueMax = _data.t5_max;
        }

      }

    },
    sliderChangeMin(event){
      var temp = event.target.id.split("_");
      this.datas[temp[2]].valueMin = event.target.value;
    },
    sliderChangeMax(event){

      var temp = event.target.id.split("_");
      this.datas[temp[2]].valueMax = event.target.value;

    },
    save(){
      
      this.saving = true;
      var objData = {
        id: this.data.id,
        data: this.datas
      }
      this.$store.dispatch('setLimits', objData)
      .then(response => {
        
        if (response){
          this.saving = false
        }
      })
      .catch(error => {
          console.log(error)
          return error
      });


    }
  }
}
</script>

<style scoped>
  .MinMax input{
      width: 50px;
      
  }
  .MinMax input[type=range].slider {
    margin: 0rem 0;
    

  }
  .MinMax button{
    float: right;
  }
  .MinMax input[type=range].slider:not([orient=vertical]).has-output+output {
    background: white ;
    color: #4a4a4a;
    border: 1px solid #cccccc;
  }
</style>
